import TextArea from '../TextArea';
import Input from '../Input';

import styled from 'styled-components';

export const InputSubject = styled(Input).attrs({
  stateName: "subject",
  name: "Assunto",
  className: "w-100",
  type: "text",
  placeholder: "Assunto",
  required: true
})``;

export const InputNameEnterprise = styled(Input).attrs({
  stateName: "enterpriseName",
  name: "Empresa",
  className: "w-100",
  type: "text",
  placeholder: "Empresa",
  required: true
})``;

export const InputName = styled(Input).attrs({
  stateName: "name",
  name: "Nome",
  className: "w-100",
  type: "text",
  placeholder: "Nome",
  required: true
})``;

export const InputPhone = styled(Input).attrs({
  stateName: "phone",
  name: "Telefone",
  className: "w-100",
  type: "telphone",
  placeholder: "Telefone",
  required: true,
  maxLength: 15,
  minLength: 14
})``;

export const InputEmail = styled(Input).attrs({
  stateName: "email",
  name: "E-mail",
  className: "w-100",
  type: "email",
  placeholder: "E-mail",
  required: true
})``;

export const TextAreaMessage = styled(TextArea).attrs({
  stateName: "message",
  name: "Mensagem",
  minLength: 10,
  maxLength: 1000,
  placeholder: "Mensagem",
  required: true,
  className: "w-100",
})`
  flex: 1;
  height: 150px;
  min-height: 150px;
`;
